import { __assign, __read } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Children, useState, cloneElement, createElement, useEffect, useCallback, Fragment } from 'react';
import { styled } from '@mui/material/styles';
import Tabs from '@mui/material/Tabs';
import MoaStyledComponent from "../../Style/MoaStyled";
import { Color } from "../../";
var StyledComponent = styled(function (props) {
    var id = props.id, width = props.width, height = props.height, minWidth = props.minWidth, minHeight = props.minHeight, tabProps = props.tabProps;
    var _a = __read(useState(props === null || props === void 0 ? void 0 : props.value), 2), value = _a[0], setValue = _a[1];
    var cloneArr = Children.map(props.children, function (child, idx) {
        if (!child)
            return createElement(Fragment, { key: idx });
        return cloneElement(child, __assign({ onChange: props === null || props === void 0 ? void 0 : props.onChange, selected: value === child.props.value }, tabProps));
    });
    var locateIndicator = useCallback(function (props) {
        if ((props === null || props === void 0 ? void 0 : props.orientation) === "vertical") {
            if ((props === null || props === void 0 ? void 0 : props.indicator) === "left")
                return { right: 'auto', left: 0 };
            else
                return { left: 'auto', right: 0 };
        }
        else
            return {};
    }, []);
    useEffect(function () {
        setValue(props === null || props === void 0 ? void 0 : props.value);
    }, [props === null || props === void 0 ? void 0 : props.value]);
    return (_jsx(Tabs, { id: id, orientation: props === null || props === void 0 ? void 0 : props.orientation, value: value, onChange: function (e, v) { var _a; return ((_a = props === null || props === void 0 ? void 0 : props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, e, v)) || setValue(v); }, "aria-label": props === null || props === void 0 ? void 0 : props['aria-label'], TabIndicatorProps: {
            style: __assign(__assign({}, locateIndicator(props)), { backgroundColor: Color.secondary.main })
        }, sx: {
            width: width !== null && width !== void 0 ? width : undefined,
            height: height !== null && height !== void 0 ? height : undefined,
            minWidth: minWidth !== null && minWidth !== void 0 ? minWidth : undefined,
            minHeight: minHeight !== null && minHeight !== void 0 ? minHeight : undefined,
        }, children: cloneArr }));
})(function () { return ({}); });
var ThemedComponent = function (props) { return (_jsx(MoaStyledComponent, { children: _jsx(StyledComponent, __assign({}, props)) })); };
export default ThemedComponent;
